import {styled} from "@mui/material";

export const SimpleTable = styled('table')(() => ({
    border: '1px solid',
    borderCollapse: 'collapse',
    width: '100%',
    '& td': {
        border: '1px solid',
        borderCollapse: 'collapse',
    },
    '& th': {
        border: '1px solid',
        borderCollapse: 'collapse',
    }
}));
